import { formatStoredRegionLabel } from './regionDisplayLabel';

/** Stored label or alias → i18n key */
const LABEL_TO_I18N_KEY = {
  '전 지역': 'regions.all',
  'All regions': 'regions.all',
  'All Areas': 'regions.all',
  미케비치: 'location.areas.myKhe',
  'My Khe': 'location.areas.myKhe',
  'My Khe Beach': 'location.areas.myKhe',
  한강: 'location.areas.hanRiver',
  'Han River': 'location.areas.hanRiver',
};

/**
 * @param {string} value — stored region / neighborhood label
 * @param {(key: string) => string} t
 * @param {string} [language]
 */
export function formatRegionLabel(value, t, language = 'ko') {
  if (value == null || value === '') return '';

  const v = String(value).trim();
  if (v.includes('·') || v.includes(' · ')) {
    return formatStoredRegionLabel(v, t, language);
  }

  if (language === 'ko') {
    if (v === '전 지역') return '전 지역';
    if (v === '미케비치') return '미케비치';
    if (v === '한강') return '한강';
  }
  if (language === 'en') {
    if (v === '전 지역' || v === 'All regions' || v === 'All Areas') return 'All regions';
    if (v === '미케비치' || v === 'My Khe' || v === 'My Khe Beach') return 'My Khe';
    if (v === '한강' || v === 'Han River') return 'Han River';
  }

  const i18nKey = LABEL_TO_I18N_KEY[v];
  if (i18nKey) {
    const translated = t(i18nKey);
    if (translated && translated !== i18nKey) return translated;
  }

  return formatStoredRegionLabel(v, t, language);
}
